import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import colors from '../../tokens/colors'
import typography from '../../tokens/typography'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const Container = styled.div``

export const Flex = styled.div.attrs((props) => composeTheme(props))`
  display: inline-flex;
  border: ${(props) => props.theme.numericInput.borderWidth} solid
    ${(props) => props.theme.numericInput.borderColor};
  border-radius: ${(props) => props.theme.numericInput.borderRadius};
`

export const Button = styled.button.attrs((props) => composeTheme(props))`
  background-color: transparent;
  border-color: transparent;
  color: ${colors.brandColorPrimaryPure};
  width: 3.6rem;
  height: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg.MuiSvgIcon-root {
    color: ${(props) =>
      props.theme?.numericInput?.buttonColor ||
      props.theme.brandColors.primaryPure};
  }

  &:disabled {
    background-color: ${colors.neutralColorHighLight};
    cursor: not-allowed;
    border-radius: ${(props) => props.theme.numericInput.borderRadius};

    svg {
      color: ${colors.neutralColorLowDark};
    }
  }
`

export const Input = styled.div.attrs((props) => composeTheme(props))`
  background-color: transparent;
  width: ${(props) => props.theme.numericInput.displayWidth};
  border-left: ${(props) => props.theme.numericInput.displayBorderWidth} solid
    ${(props) => props.theme.numericInput.displayBorderColor};
  border-right: ${(props) => props.theme.numericInput.displayBorderWidth} solid
    ${(props) => props.theme.numericInput.displayBorderColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${fonts.inter};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightRegular};
  font-size: ${typography.fontSize.fontSizeXs};

  &.is-disabled {
    background-color: ${colors.neutralColorHighLight};
  }
`

Button.defaultProps = defaultTheme
